import React, { useEffect, useRef } from "react";
import * as SpinStyles from "./styles/Spin";
import * as Styles from "./styles/InteriorSpin";
import PreLoader from "../../../../../../../common-deprecated/styles/toyota/Preloader";
import useInteriorSpin from "../../../../hooks/shared/useInteriorSpin";
import { BnbLabel } from "../../../../utils/labels";
import IconRefresh from "../../../../svg/toyota/refresh.svg";
import { trackCustomizeInt360Spin } from "../../../../utils/tracking";
import { useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";

type PropsType = {
    visible?: boolean;
    fullscreen?: boolean;
    getByFrame?: boolean; // When the interior spin needs to use the modernized getFrame function instead of the classic getImage call for it's frames
    gradeId?: string;
    bodyTypeId?: string;
};

const InteriorSpin3D = (props: PropsType): JSX.Element => {
    const { visible, fullscreen, getByFrame, gradeId, bodyTypeId } = props;

    const canvasElement = useRef<HTMLCanvasElement>(null);
    const { loading, initialized, dragged } = useInteriorSpin(
        canvasElement,
        !!visible,
        !!fullscreen,
        !!getByFrame,
        gradeId,
        bodyTypeId,
    );
    const step = useBnbSelector((state) =>
        state.bnbSettings.showMergedModelStep && state.navigation.step === NavStep.Model
            ? NavStep.ModelEngine
            : state.navigation.step,
    );

    // Track the first time the user changed the car angle
    const anyCarWasSpun = useRef(false);
    useEffect(() => {
        if (anyCarWasSpun.current || !dragged) return;
        anyCarWasSpun.current = true;
        trackCustomizeInt360Spin(step);
    }, [dragged]);

    return (
        <Styles.Wrapper fullscreen={fullscreen}>
            {loading || !initialized ? (
                <PreLoader delayedVisibility />
            ) : (
                !dragged && (
                    <SpinStyles.CenterLabel type="button" hasText tabIndex={-1}>
                        <IconRefresh width="16" height="16" />
                        <BnbLabel label="spinDragToRotate" />
                    </SpinStyles.CenterLabel>
                )
            )}
            <Styles.CanvasWrapper>
                <canvas ref={canvasElement} />
            </Styles.CanvasWrapper>
        </Styles.Wrapper>
    );
};

export default InteriorSpin3D;
